export default {
    updateJSON: (state, payload) => {
      state.jsonData = payload;
    }
  };
